<template>
  <div class="buttonlist">
    <div class="buttonlist-m" style="padding:24px">
      <h3 style="margin-bottom:12px">任务自动生成（PRD 6.6.3）</h3>
      <p style="color:#666;line-height:1.8;margin-bottom:20px">
        根据机构内<strong>全部生效中</strong>的护理计划，为每位老人生成/刷新未来 7 天内的待执行任务（已执行/进行中的任务不受影响）。
      </p>
      <el-button type="primary" :loading="loading" @click="generate">立即生成任务</el-button>
      <p v-if="lastResult !== null" style="margin-top:16px;color:#52C41A">上次处理计划数：{{ lastResult }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "NursingTaskGenerate",
  data() { return { loading: false, lastResult: null }; },
  methods: {
    generate() {
      this.$confirm("确认为全部生效中计划生成/刷新任务？", "提示", { type: "warning" }).then(() => {
        this.loading = true;
        this.$postJson("omc/nursingTask/generateDaily", {}).then(res => {
          this.loading = false;
          if (res.code == 200) {
            this.lastResult = res.result;
            this.$message.success(res.message || "生成完成");
          } else this.$message.error(res.message);
        }).catch(() => { this.loading = false; });
      });
    }
  }
};
</script>
